// CC: extracted from integrations.component.ts -> Powershell popup section
import * as util from 'util';
import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {Router} from "@angular/router";
import {GeneralService} from '../../../../../services/generalService';
import {DICTIONARY} from '../../../../../dictionary';
import {RouteService} from '../../../../../services/routeService';
import {NotificationService} from '../../../../../services/notificationService';

@Component({
	selector: 'powershell-integration-component',
	templateUrl: './powershell-integration.component.html',
})
export class PowershellIntegrationComponent implements OnInit {
	@Output() connectionChanged = new EventEmitter<void>();
	@Input() pageOrigin; // inbound, outbound, admin
	dic = DICTIONARY;
	planInfo: any;
	integrationActionInProcess = false;

	// CC: taken from integrations.component.ts -> exchangePowershellCommands
	exchangePowershellCommands = {
		login: 'login',
		verify: 'verify',
		disconnect: 'disconnect',
		enableSyncQuarantine: 'enableSyncQuarantine',
		enableAutomaticRelease: 'enableAutomaticRelease',
		autoReleaseForReScan: 'autoReleaseForReScan',
		quarantine: 'quarantine',
		rules: 'rules',
		updateRules: 'updateRules',
		protection: 'protection',
		junkRule: 'junkRule',
		configuration: 'configuration'
	};

	exchangePowershellPopup: any = {};

	constructor(public gs: GeneralService, private rs: RouteService,
				private ns: NotificationService, private router: Router) {
	}

	ngOnInit() {
		// CC: fall back to router-based detection when pageOrigin is not passed as input
		if (!this.pageOrigin) {
			if (this.router.url.includes(this.dic.CONSTANTS.appStates.adminInbound)) {
				this.pageOrigin = 'inbound';
			}
			else if (this.router.url.includes(this.dic.CONSTANTS.appStates.adminOutbound)) {
				this.pageOrigin = 'outbound';
			}
			else {
				this.pageOrigin = 'admin';
			}
		}
		this.getIntegrations();
	}

	getIntegrations = () => {
		this.rs.getIntegrations().then((planInfo) => {
			this.planInfo = planInfo;
		});
	}

	isConnected = () => {
		return !!(this.planInfo?.powershell?.enabled && (this.planInfo?.powershell?.refresh_token || this.planInfo?.exchange_server?.exoadmin_enabled));
	}

	// CC: taken from integrations.component.ts -> connectToPowershell
	connectToPowershell = () => {
		if (this.isConnected()) {
			this.gs.showPopup({
				title: 'Disconnect from PowerShell',
				subTitle: `Please note - you are about to cancel the connection to your Exchange Server PowerShell`,
				body: ["You will not be able to do any powershell related operations"],
				type: this.dic.CONSTANTS.popupWarning,
				doneBtnText: 'Disconnect',
				doneCb: () => {
					this.integrationActionInProcess = true;
					let disconnectFlow = this.planInfo.exchange_server?.exoadmin_enabled ? this.rs.disconnectExchange({onlyExoadmin: true}) : this.rs.exchangeDeviceDisconnect();
					disconnectFlow.then(() => {
						this.integrationActionInProcess = false;
						this.ns.showInfoMessage('Successfully disconnected from Exchange Server PowerShell');
						this.planInfo.powershell = {enabled: false};
						this.exchangePowershellPopup[this.exchangePowershellCommands.login] = null;
						this.connectionChanged.emit();
					}, () => {
						this.integrationActionInProcess = false;
					});
				}
			});
		}
		else {
			this.openExchangePowershellPopup(this.exchangePowershellCommands.login);
		}
	}

	// CC: taken from integrations.component.ts -> closeExchangePowershellPopup
	closeExchangePowershellPopup = (type, success, disconnected) => {
		if (type === this.exchangePowershellCommands.login && success) {
			if (!this.planInfo.powershell.enabled) {
				this.planInfo.powershell = {enabled: true, refresh_token: true};
			}
			else {
				this.planInfo.powershell.refresh_token = true;
			}
			this.connectionChanged.emit();
		}

		if (disconnected) {
			this.planInfo.powershell.refresh_token = false;
			this.connectionChanged.emit();
		}

		this.exchangePowershellPopup[type] = null;
	}

	// CC: taken from integrations.component.ts -> openExchangePowershellPopup
	openExchangePowershellPopup = (type, source = null) => {
		switch (type) {
			case this.exchangePowershellCommands.verify:
				this.integrationActionInProcess = true;
				this.rs.exchangeVerifyLogin().then(() => {
					this.integrationActionInProcess = false;
					this.ns.showInfoMessage('Successfully connected to Exchange Server PowerShell');
				}, (err) => {
					if (err.data?.disconnected) {
						this.planInfo.powershell.refresh_token = false;
					}
					this.integrationActionInProcess = false;
				});
				return;

			case this.exchangePowershellCommands.enableSyncQuarantine:
				this.integrationActionInProcess = true;
				this.rs.powershellQuarantineAction('sync', {enabled: this.planInfo.powershell.sync_quarantine}).then(() => {
					this.integrationActionInProcess = false;
					this.ns.showInfoMessage('Successfully enabled synchronization to Exchange Server quarantined emails');
					if (!this.planInfo.powershell.sync_quarantine) {
						this.planInfo.powershell.automatic_release = false;
						this.planInfo.powershell.rescan_after_exchange_release = false;
					}
				}, () => {
					this.planInfo.powershell.sync_quarantine = !this.planInfo.powershell.sync_quarantine;
					this.integrationActionInProcess = false;
				});
				return;

			case this.exchangePowershellCommands.enableAutomaticRelease:
				this.integrationActionInProcess = true;
				this.rs.powershellQuarantineAction('autoRelease', {enabled: this.planInfo.powershell.automatic_release}).then(() => {
					this.integrationActionInProcess = false;
					this.ns.showInfoMessage(`Successfully ${this.planInfo.powershell.automatic_release ? 'enabled' : 'disabled'} Automatic Release`);
					if (!this.planInfo.powershell.automatic_release) {
						this.planInfo.powershell.rescan_after_exchange_release = false;
					}
				}, () => {
					this.planInfo.powershell.automatic_release = !this.planInfo.powershell.automatic_release;
					this.integrationActionInProcess = false;
				});
				return;

			case this.exchangePowershellCommands.autoReleaseForReScan:
				this.integrationActionInProcess = true;
				this.rs.powershellQuarantineAction(this.exchangePowershellCommands.autoReleaseForReScan, {enabled: this.planInfo.powershell.rescan_after_exchange_release}).then(() => {
					this.integrationActionInProcess = false;
					this.ns.showInfoMessage(`Successfully ${this.planInfo.powershell.rescan_after_exchange_release ? 'enabled' : 'disabled'} scan and release safe emails`);
				}, () => {
					this.planInfo.powershell.rescan_after_exchange_release = !this.planInfo.powershell.rescan_after_exchange_release;
					this.integrationActionInProcess = false;
				});
				return;

			case this.exchangePowershellCommands.junkRule:
				if (source === 'inbound' && !this.planInfo.inbound_relay?.enabled) {
					const url = this.gs.buildInternalUrl(`/${DICTIONARY.CONSTANTS.appStates.adminInbound}/${DICTIONARY.CONSTANTS.adminPages.inbound.plan}/${DICTIONARY.CONSTANTS.inboundPlanSettingsPageTabs.emailFlowIntegration}`);
					const message = util.format(DICTIONARY.ERRORS.wizardNoRelay,
						'Inbound',
						`<a target="_self" href="${url}"><b><i>Mail Flow Integration page</i></b></a>`);
					this.ns.showErrorMessage(message);
					return;
				}
				this.exchangePowershellPopup[type] = {show: true};
				break;

			case this.exchangePowershellCommands.rules:
				if (source === 'inbound' && !this.planInfo.inbound_relay?.enabled) {
					const url = this.gs.buildInternalUrl(`/${DICTIONARY.CONSTANTS.appStates.adminInbound}/${DICTIONARY.CONSTANTS.adminPages.inbound.plan}/${DICTIONARY.CONSTANTS.inboundPlanSettingsPageTabs.emailFlowIntegration}`);
					const message = util.format(DICTIONARY.ERRORS.wizardNoRelay,
						'Inbound',
						`<a target="_self" href="${url}"><b><i>Mail Flow Integration page</i></b></a>`);
					this.ns.showErrorMessage(message);
					return;
				}
				else if (source === 'outbound' && !this.planInfo.outbound_relay?.enabled) {
					const url = this.gs.buildInternalUrl(`/${DICTIONARY.CONSTANTS.appStates.adminOutbound}/${DICTIONARY.CONSTANTS.adminPages.outbound.sharedPlan}/${DICTIONARY.CONSTANTS.outboundPlanSettingsPageTabs.emailFlowIntegration}`);
					const message = util.format(DICTIONARY.ERRORS.wizardNoRelay,
						'Outbound',
						`<a target="_self" href="${url}"><b><i>Mail Flow Integration page</i></b></a>`);
					this.ns.showErrorMessage(message);
					return;
				}

				this.exchangePowershellPopup[type] = {show: true, source};

				let verifiedDomains = [];
				if (this.planInfo.exchange_server.enabled && this.planInfo.exchange_server.verified_domains?.length) {
					verifiedDomains = this.planInfo.exchange_server.verified_domains;
				}
				else {
					verifiedDomains = this.planInfo.domains.filter(domain => domain.verified).map(domain => domain.domain);
				}
				this.exchangePowershellPopup[type].domains = verifiedDomains;
				break;

			default:
				this.exchangePowershellPopup[type] = {show: true};
				break;
		}
	}

	// CC: taken from integrations.component.ts -> openPowershellAutoReleasePopup
	openPowershellAutoReleasePopup = () => {
		this.gs.showPopup({
			title: 'Release Quarantined Emails',
			subTitle: `All quarantined emails in Exchange will be released. This operation can take a few minutes.`,
			body: [],
			type: this.dic.CONSTANTS.popupWarning,
			doneBtnText: 'Confirm',
			doneCb: () => {
				this.rs.powershellQuarantineAction('autoReleaseExecute', {enabled: this.planInfo.powershell.automatic_release}).then(() => {
					this.integrationActionInProcess = false;
					this.ns.showInfoMessage('Successfully called for release of quarantine emails');
				}, () => {
					this.integrationActionInProcess = false;
				});
			}
		});
	}

	// CC: taken from integrations.component.ts -> syncPowershellBlocklists
	syncPowershellBlocklists = () => {
		this.integrationActionInProcess = true;
		this.rs.exchangeSyncBlocklist().then(() => {
			this.ns.showInfoMessage('Blocklists successfully synced from Exchange');
			this.integrationActionInProcess = false;
		}, () => {
			this.integrationActionInProcess = false;
		});
	}
}
